import {
  SIMULADOR_FINANCIERO_GET_BRANDS_BEGIN,
  SIMULADOR_FINANCIERO_GET_BRANDS_SUCCESS,
  SIMULADOR_FINANCIERO_GET_BRANDS_FAILURE,
  SIMULADOR_FINANCIERO_GET_BRANDS_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { CATALOGO_ENDPOINT } from 'common/endpoints'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getBrands(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SIMULADOR_FINANCIERO_GET_BRANDS_BEGIN,
    });
    // TODO: preferir usar librería de npm query-string (está en el proyecto)
    // ver ejemplos usando el buscador con query-string y QS_CONFIG

    const queryString = Object.keys(args).reduce((acc, key) => {
      if(key === 'car_lot_id') {
        args[key].forEach(element => {
          acc += `${key}=${element}&`;
        });
      } else {
        acc += `${key}=${args[key]}&`;
      }

      return acc;
    }, '')

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(CATALOGO_ENDPOINT + "/brands?" + queryString);
      doRequest.then(
        (res) => {
          const brandsAndCarLots = res.data.data.map(item => {
            item.name = `${item.name} - ${item.car_lot_name}`
            return item
          })
          dispatch({
            type: SIMULADOR_FINANCIERO_GET_BRANDS_SUCCESS,
            data: brandsAndCarLots,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_GET_BRANDS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetBrandsError() {
  return {
    type: SIMULADOR_FINANCIERO_GET_BRANDS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_GET_BRANDS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getBrandsPending: true,
        getBrandsError: null
      };

    case SIMULADOR_FINANCIERO_GET_BRANDS_SUCCESS:
      // The request is success
      return {
        ...state,
        getBrandsPending: false,
        getBrandsError: null,
        marcas: action.data
      };

    case SIMULADOR_FINANCIERO_GET_BRANDS_FAILURE:
      // The request is failed
      return {
        ...state,
        getBrandsPending: false,
        getBrandsError: action.data.error,
      };

    case SIMULADOR_FINANCIERO_GET_BRANDS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getBrandsError: null,
      };

    default:
      return state;
  }
}
